import axios from 'axios';

import {
  DraftModel,
  PetBlockModel,
  QuickSaleModel,
  VariantModel,
} from '../models/QuickSaleModel';

const API_URL = process.env.REACT_APP_API_URL;

function quickSaleUrl(userId: number) {
  return `${API_URL}/api/crm/quick-sale/${userId}/`;
}

export interface DraftRequest {
  pet_id: number;
  plan_id: number | null;
  draft: DraftModel;
}

export function getQuickSale(
  userId: number
): Promise<{ data: QuickSaleModel }> {
  return axios.get(quickSaleUrl(userId));
}

/** Applies the draft and rolls it back: the prices saving would produce. */
export function simulateDraft(
  userId: number,
  request: DraftRequest
): Promise<{ data: PetBlockModel }> {
  return axios.post(`${quickSaleUrl(userId)}simulate/`, request);
}

export function applyDraft(
  userId: number,
  request: DraftRequest
): Promise<{ data: PetBlockModel }> {
  return axios.post(`${quickSaleUrl(userId)}apply/`, request);
}

export function getPlanVariants(
  userId: number,
  planId: number
): Promise<{ data: { plan_id: number; variants: Array<VariantModel> } }> {
  return axios.get(`${quickSaleUrl(userId)}variants/`, {
    params: { plan: planId },
  });
}
